import { render, staticRenderFns } from "./UserProfileStatsCourses.vue?vue&type=template&id=7578bfac"
import script from "./UserProfileStatsCourses.vue?vue&type=script&lang=js"
export * from "./UserProfileStatsCourses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports